<template>
  <div>
    <Button type="primary" style="margin-bottom: 20px" @click="addType('1')">新增</Button>
    <Button type="primary" style="margin-bottom: 20px" ghost v-if="unfold" @click="closeTree()"
      >全部收起
      <Icon type="ios-arrow-up" />
    </Button>
    <Button type="primary" style="margin-bottom: 20px" ghost v-else @click="openTree()"
      >全部展开
      <Icon type="ios-arrow-down" />
    </Button>
    <div class="table-box template-table">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" row-key="id" :update-show-children="true">
        <template slot-scope="{ row }" slot="name">
          <span class="blue" @click="addType('3', row)">
            {{ row.name }}
          </span>
        </template>

        <template slot-scope="{ row, index }" slot="move">
          <div>
            <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-xiangshang" @click="moveUp(row, index)"></i></span>
            <span v-if="row._length != index + 1" class="table-btn"><i class="iconfont iconyidongxiangxia" @click="moveDown(row, index)"></i></span>
            <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-zhiding" @click="toTop(row, index)"></i></span>
            <span v-if="row._length != index + 1" class="table-btn"><i class="iconfont iconyidong-zhidi" @click="toBottom(row, index)"></i></span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="enableFlag">
          <div>
            <i-switch v-model="row.enableFlag" true-value="1" false-value="0" @on-change="isEnableChange(row)">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </template>

        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="$refs.setProduct.open(row)">产品</span>
            <span class="table-btn" @click="addType('2', row)" v-if="row.level == '1'">新增子分类</span>
            <span class="table-btn red" @click="deleteProduct(row)">删除</span>
          </div>
        </template>
      </Table>
      <!-- 新增分类 -->
      <Modal v-model="visible" :title="title" :footer-hide="true" :mask-closable="false" width="900">
        <Form ref="form" :model="formData" :label-width="130">
          <FormItem label="商品库分类名称" prop="name" :rules="$units.formRule.required('请输入商品库分类名称')">
            <Input type="text" v-model="formData.name" placeholder="请输入" maxlength="6" show-word-limit clearable />
          </FormItem>
          <FormItem label="属于一级分类" v-if="addTypeLe">
            <span>{{ formData.parentName }}</span>
          </FormItem>
          <FormItem label="是否有效">
            <i-Switch v-model="formData.enableFlag" true-value="1" false-value="0">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-Switch>
          </FormItem>
        </Form>
        <div class="ivu-modal-footer">
          <Button type="text" @click="visible = false">取消</Button>
          <Button type="primary" @click="addProductType">确定</Button>
        </div>
      </Modal>
      <!-- 设置产品分类 -->
      <set-product ref="setProduct" @reload="getList()"></set-product>
    </div>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import setProduct from './components/setProduct';
export default {
  components: { setProduct },
  mixins: [pageTool],
  data() {
    return {
      formData: {
        enableFlag: '1'
      },
      title: '',
      unfold: false,
      addTypeLe: false,
      visible: false,
      listLoading: false, //表格loading
      isShowEdit: false,
      level: '1',
      columns: [
        //表格字段
        {
          title: '分类名称',
          tree: true,
          key: 'name',
          slot: 'name'
        },
        {
          title: '排序',
          slot: 'move',
          align: 'center'
        },
        {
          title: '是否有效',
          slot: 'enableFlag',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ],
      tableData: [], //表格数据
      tableData2: []
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    //数组元素互换位置进行上移下移
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    // 请求移动接口
    moveHttp(isLevelOne) {
      let list = [];
      if (isLevelOne) {
        list = JSON.parse(JSON.stringify(this.tableData));
      } else {
        list = JSON.parse(JSON.stringify(this.tableData2));
      }
      let thisList = [];
      thisList = list.map(item => {
        return item.id;
      });
      this.$http({
        url: '/buz/merchantProductTheme/sort',
        type: 'POST',
        data: thisList
      });
    },
    // 上移
    moveUp(item, index) {
      // 处理一级上移
      if (item.parentId == '0') {
        this.swapArray(this.tableData, index - 1, index);
        this.moveHttp(true);
      } else {
        let list = this.tableData.filter(data => data.id == item.parentId);
        this.tableData2 = list[0].children;
        this.swapArray(this.tableData2, index - 1, index);
        this.moveHttp(false);
      }
    },
    // 下移
    moveDown(item, index) {
      // 处理一级下移
      if (item.parentId == '0') {
        this.swapArray(this.tableData, index, index + 1);
        this.moveHttp(true);
      } else {
        let list = this.tableData.filter(data => data.id == item.parentId);
        this.tableData2 = list[0].children;
        this.swapArray(this.tableData2, index, index + 1);
        this.moveHttp(false);
      }
    },
    // 置顶
    toTop(item, index) {
      // 处理一级置顶
      if (item.parentId == '0') {
        this.tableData.unshift(this.tableData.splice(index, 1)[0]);
        this.moveHttp(true);
      } else {
        let list = this.tableData.filter(data => data.id == item.parentId);
        this.tableData2 = list[0].children;
        this.tableData2.unshift(this.tableData2.splice(index, 1)[0]);
        this.moveHttp(false);
      }
    },
    // 置底
    toBottom(item, index) {
      // 处理一级置底
      if (item.parentId == '0') {
        this.tableData.push(this.tableData.splice(index, 1)[0]);
        this.moveHttp(true);
      } else {
        let list = this.tableData.filter(data => data.id == item.parentId);
        this.tableData2 = list[0].children;
        this.tableData2.push(this.tableData2.splice(index, 1)[0]);
        this.moveHttp(false);
      }
    },
    addProductType() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$http({
            type: 'POST',
            url: this.formData.id ? '/buz/merchantProductTheme/edit' : '/buz/merchantProductTheme/add',
            data: {
              ...this.formData,
              level: this.level
            }
          }).then(res => {
            this.getList();
            this.visible = false;
          });
        }
      });
    },
    deleteProduct(row) {
      let tips;
      if (row.parentId == '0') {
        tips = '该分类下的子分类将一并删除，请确认是否删除';
      } else {
        tips = '确定要删除此分类吗？';
      }
      this.$notice.inquiry(tips).then(() => {
        this.$http({
          type: 'GET',
          url: '/buz/merchantProductTheme/del',
          data: {
            id: row.id
          }
        }).then(res => {
          this.getList();
        });
      });
    },
    isEnableChange(row) {
      this.$http({
        type: 'GET',
        url: '/buz/merchantProductTheme/enable',
        data: {
          id: row.id,
          enable: row.enableFlag
        }
      }).then(res => {
        this.getList();
      });
    },
    getList() {
      this.listLoading = true;
      this.$http({
        type: 'POST',
        url: '/buz/merchantProductTheme/read/list',
        data: {}
      })
        .then(res => {
          this.listLoading = false;
          this.tableData.forEach(item => {
            res.data.forEach(i => {
              if (item.id == i.id) {
                i._showChildren = item._showChildren;
              }
            });
          });
          this.tableData = res.data;
        })
        .catch(err => {
          this.listLoading = false;
        });
    },
    closeTree() {
      this.tableData = this.tableData.map((item, index) => ({
        ...item,
        _showChildren: false,
        _length: item.parentId == '0' ? this.tableData.length : this.tableData.length,
        children: item.children ? this.handleTableTree(item.children) : []
      }));
      this.unfold = false;
    },
    openTree() {
      this.tableData = this.tableData.map((item, index) => ({
        ...item,
        _showChildren: true,
        _length: item.parentId == '0' ? this.tableData.length : this.tableData.length,
        children: item.children ? this.handleTableTree(item.children) : []
      }));
      this.unfold = true;
    },
    // 处理树形数据
    handleTableTree(arr) {
      return arr.map((item, index) => ({
        ...item,
        _showChildren: true,
        _length: item.parentId == '0' ? arr.length : arr.length,
        children: item.children ? this.handleTableTree(item.children) : []
      }));
    },
    clearMessage() {
      this.$refs.form.fields.forEach(item => {
        item.validateState = '';
        item.validateMessage = '';
      });
    },
    addType(i, row) {
      this.clearMessage();
      this.$refs.form && this.$refs.form.resetFields();
      this.visible = true;
      this.formData = {
        enableFlag: '1'
      };
      if (i == '1') {
        this.title = '新增一级分类';
        this.addTypeLe = false;
        this.level = '1';
      } else if (i == '2') {
        this.title = '新增二级分类';
        this.addTypeLe = true;
        this.level = '2';
        this.formData.parentName = row.name;
        this.formData.parentId = row.id;
      } else if (i == '3') {
        this.formData = row;
        if (row.parentId == '0') {
          this.title = '编辑一级分类';
          this.addTypeLe = false;
          this.level = '1';
        } else {
          this.title = '编辑二级分类';
          this.addTypeLe = true;
          this.level = '2';
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-table-cell {
  display: flex;
}
.blue {
  margin-left: 6px;
  color: #236dff;
  cursor: pointer;
}
</style>